import {post} from '@/api/rest/ajax'
import {restUrls} from '@/api/rest/url'
import {getTemplate} from './cloudPrintHelper'
import {userInfo, $notify} from '@/global'
import _ from 'lodash'
import * as localStorage from '../utils/storage/localStorage'
import { i18n } from '../i18n'
import axios from 'axios'
import { commonAddLog } from '../biz/shipment/pack/paperlessPackageTag'
import { queryCloudPrintConfigList } from '@/api/biz/shipment/shipmentService'
import {SgmPrintMonitor} from '@/api/lib/monitor/printMonitor'
import { printPointEnd } from '@/utils/setMethods'

/**
 * 云打印方法
 * @param content
 * @param printNum 打印份数
 */
export async function cloudPrint (content,printNum = 1) {
  console.log("🚀 ~ cloudPrint ~ content:", content)
  // 获取模板信息
  let template = getTemplate(content.templateId);
  let startTime=new Date().getTime()
  if(_.isEmpty(template) && !_.isEmpty(content.base64BinaryEncoding)) {
    console.log('进入base64文件流打印' + content.printerName);
    let selectedPrinterName = content.printerName;
    if (!selectedPrinterName || selectedPrinterName == '') {
      selectedPrinterName = 'order';
    }
    console.log('selectedPrinterName:' + selectedPrinterName);
    let orderDefaultPrinter = localStorage.getLocalStorgeValue(selectedPrinterName);
    if(!orderDefaultPrinter || orderDefaultPrinter == '') {
      printPointEnd('cloudPrint2',startTime,{
        eptCustMessage:'云打印错误：没有设置默认打印机'
      });
      $notify.error(i18n.t('noDefaultPrinter',[selectedPrinterName]));
      return;
    }
    let printContent = {};
    printContent.type =1;
    printContent.base64 = content.base64BinaryEncoding;
    printContent.printerName = orderDefaultPrinter;
    printContent.traceId=(window.printTrackObj && window.printTrackObj.traceId) ||''
    printContent.curPage=1
    printContent.pageSize=1
    try {
      console.log("云打印，打印份数：" + printNum);
      for (let index = 0; index < printNum; index++) {
        let startTime = new Date().getTime();
        console.log("云打印，无模板打印第："+(index+1)+"份，打印内容：" + JSON.stringify(printContent));
        await axios.post(restUrls.cloud_print_base64_image,printContent,{
          headers:{'X-Requested-With': 'XMLHttpRequest', "Access-Control-Allow-Origin":"*",'Content-Type':'application/json;charset=utf-8'
          }});
        printPointEnd('cloudPrint2',startTime);
      }
      // printEnd(true)
      // const promises = [];
      // for (let index = 0; index < printNum; index++) {
      //     let startTime = new Date().getTime();
      //     console.log("云打印，无模板打印第：" + (index + 1) + "份，打印内容：" + JSON.stringify(printContent));
      //     const promise = axios.post(restUrls.cloud_print_base64_image, printContent, {
      //         headers: {
      //             'X-Requested-With': 'XMLHttpRequest',
      //             'Access-Control-Allow-Origin': '*',
      //             'Content-Type': 'application/json;charset=utf-8'
      //         }
      //     });
      //     promises.push({ promise, startTime });
      // }
      // await Promise.all(promises.map(async ({promise, startTime}) => {
      //   await promise;
      //   printPointEnd(content, 1, startTime);
      // }));
      // printEnd(true); 
    } catch(e){
      commonAddLog(
        'cloudPrint.js',
        'cloudPrint',
        `云打印异常信息：${e}；请求地址：${restUrls.cloud_print_base64_image};请求参数：${JSON.stringify(printContent)}`
      );
      printPointEnd('cloudPrint2',startTime,{
        eptCustMessage:'云打印错误：云打印客户端未开启'
      });
      $notify.error(i18n.t('notopencloudprinterError'));
      return;
    }
    return;
  }
  console.log("🚀 ~ cloudPrint ~ content:", content)
  let requestData = {}
  if (!content.useLocalPrint) {
    if (_.isEmpty(template)) {
      console.log("云打印获取模板信息为空")
      $notify.error("Cloud print to obtain template information is empty.")
      return
    }
    // 从库里读取
    const cloudTemplateData = await getCloudPrintConfigList(template)
    template = cloudTemplateData || template
    console.log('cloudTemplateData', template)

    
    requestData.sys = template[0].sys;
    requestData.template = template[0].name;
    requestData.templateVer = template[0].version;
    requestData.time = new Date().getTime();
    requestData.location = '';
    requestData.user = userInfo.userCode
    requestData.orderNum = content.orderNum;
    if(content && content.printPDF === 1 && content.pdfSrc){
      requestData.printPDF = 1
      requestData.pdfSrc = content.pdfSrc
    }
    // let model = [];
    // model.push(content.data);
    // requestData.model = model;
    const modelItem=JSON.parse(JSON.stringify(content.data))
    if(modelItem){
      modelItem.traceId=(window.printTrackObj&&window.printTrackObj.traceId) || ''
      modelItem.curPage=1
      modelItem.pageSize=1
    }
    requestData.model = [modelItem];
  } else {
    if (content.sys) {
      requestData.sys = content.sys;
    } else {
      requestData.sys = 'WMS_i18n';
    }
    requestData.template = content.template;
    requestData.templateVer = content.templateVer;
    requestData.time = new Date().getTime();
    requestData.location = '';
    requestData.user = userInfo.userCode
    requestData.orderNum = content.orderNum;
    requestData.model = content.model;
  }  
  console.log("云打印，打印份数：" + printNum)
  console.log("🚀 ~ cloudPrint ~ model:", requestData)
  for (let index = 0; index < printNum; index++) {
      let startTime = new Date().getTime();
      console.log("云打印，打印第："+(index+1)+"份，打印内容：" + JSON.stringify(requestData))
      await post(restUrls.cloud_print_url, requestData, true);
      console.log("云打印结束",new Date().getTime()-startTime)
      printPointEnd('cloudPrint2',startTime)
  }
  // const promises = [];
  // for (let index = 0; index < printNum; index++) {
  //     let startTime = new Date().getTime();
  //     console.log("云打印，打印第："+(index+1)+"份，打印内容：" + JSON.stringify(requestData))
  //     const promise = axios.post(restUrls.cloud_print_url, requestData, true);
  //     promises.push({ promise, startTime });
  // }
  // await Promise.all(promises.map(async ({promise, startTime}) => {
  //   await promise;
  //   printPointEnd(content, 1, startTime);
  // }));

  console.info("url" + restUrls.cloud_print_url + "打印完成" +"requestData" +requestData)
}


// 云打印获取模板
export async function getCloudPrintConfigList(template = []) {
  if(_.isEmpty(template)){
    console.log("云打印获取模板信息为空")
    return
  }
  console.log('template', template)
  const {name, sys} = template[0]
  let templateWarehouseNo= `${name}_${userInfo.warehouseNo}`
  const cloudVersionDataListStr = window.sessionStorage.getItem('app_iwms_cloudPrintTemplateVersion')
  let storageTemplateVersion
  let cloudVersionData
  if(cloudVersionDataListStr) {
    cloudVersionData = JSON.parse(cloudVersionDataListStr)
    storageTemplateVersion = cloudVersionData && cloudVersionData[templateWarehouseNo] ? cloudVersionData[templateWarehouseNo] : ''
  }
  if(storageTemplateVersion) {
    console.log(`读取缓存成功，缓存版本: ${storageTemplateVersion}`)
    const returnData = {
      name,
      sys,
      version: storageTemplateVersion
    }
    SgmPrintMonitor('cloudPrint_getCloudPrintTemplate', 0, returnData)
    return [returnData]
  }
  const params = {
    warehouseNo: userInfo.warehouseNo,
    templateNo: name,
    cloudSystemNo: sys || 'WMS_i18n',
    startRow: 1,
    pageSize: 1000
  }
  try {
    let startTime = new Date().getTime();
    const result = await queryCloudPrintConfigList(params)
    let endTime = new Date().getTime();
    SgmPrintMonitor('cloudPrint_queryCloudPrintConfigList', endTime - startTime, {time: endTime - startTime, ...params})
    if(result && !_.isEmpty(result.resultList)){
      const cloudPrintData = result.resultList[0]
      let templateNoWarehouseNo= `${cloudPrintData.templateNo}_${userInfo.warehouseNo}`
      let versionInfo = {
        [templateNoWarehouseNo]: cloudPrintData.templateVersion
      }
      if(cloudVersionData && !cloudVersionData[templateNoWarehouseNo]) {
        cloudVersionData[templateNoWarehouseNo] = cloudPrintData.templateVersion
        versionInfo = cloudVersionData
      }
      window.sessionStorage.setItem('app_iwms_cloudPrintTemplateVersion', JSON.stringify(versionInfo))
      console.log(`设置缓存成功，缓存版本: ${cloudPrintData.templateVersion}`)
      SgmPrintMonitor('cloudPrint_setCloudPrintTemplate', 0, cloudPrintData)
      return [{
        name: cloudPrintData.templateNo,
        sys: cloudPrintData.cloudSystemNo,
        version: cloudPrintData.templateVersion,
        templateNote: cloudPrintData.templateNote
      }]
    }
    return template
  } catch (error) {
    console.log(error)
  }
}
